<template>
  <v-card flat class="pa-4" style="background: transparent;">
    <v-row no-gutters class="pa-6">
      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="createRemoveUsers" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ `${$tc('create', 2)}/${$tc('remove', 2)} ${$tc('user', 2)}` }}</strong>
          </p>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="listUsers" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ $tc('list_users') }}</strong>
          </p>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="monitorRemoteLog" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ $tc('monitor_remote_log') }}</strong>
          </p>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="backupRestore" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ `${$tc('execute')}/${$tc('restore')} ${$tc('backup')}` }}</strong>
          </p>
        </v-row>
      </v-col>

      <v-col cols="12" class="mb-2">
        <v-row no-gutters>
          <v-icon v-if="firmwareUpdate" size="22" class="mr-2">
            check
          </v-icon>
          <v-icon v-else size="22" class="mr-2">
            clear
          </v-icon>
          <p class="subheading mb-0">
            <strong>{{ $tc('firmware_update') }}</strong>
          </p>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  created () {
    this.setPermissions()
  },
  data () {
    return {
      createRemoveUsers: false,
      listUsers: false,
      monitorRemoteLog: false,
      backupRestore: false,
      firmwareUpdate: false
    }
  },
  computed: {
    acl () {
      return this.$store.state.auth.acl
    }
  },
  methods: {
    setPermissions () {
      const perm = this.$store.getters['auth/getPermissions']

      this.createRemoveUsers = perm.canCreateAndDeleteUser
      this.listUsers = perm.canListUser
      this.monitorRemoteLog = perm.canUserAccessRemoteLog
      this.backupRestore = perm.canUserRestoreBackup
      this.firmwareUpdate = perm.canUserUpdateFirmware
    }
  },
  watch: {
    acl () {
      this.setPermissions()
    }
  }
}
</script>
